module.exports = __webpack_public_path__ + "static/media/green-win.fd469399.png";